import { Component, Input, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { FilterListComponent } from 'gung-list';
import { EdiMinDateConfigService } from '../../../services/edi-min-date-config.service';
import { format, subMonths, parseISO } from 'date-fns';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'lib-edi-list-wrapper',
  template: `
    <h3 class="d-block page-title text-center" translate>{{ title }}</h3>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div *ngIf="showEmptyFilteredSuggestion" class="date-range-suggestion">
        <span translate>NO_ORDERS_FOUND_TRY_EXTENDING_DATE_RANGE</span>
        <button class="btn btn-primary ms-1 p-1" (click)="loadSixMonthsBack()" translate>LOAD_6_MONTHS_BACK</button>
      </div>
      <div *ngIf="!showEmptyFilteredSuggestion"></div>
      <div class="d-flex align-items-center">
        <i *ngIf="loading" class="fa fa-spinner fa-spin me-2"></i>
        <i *ngIf="showCheckmark" class="fa fa-check text-success me-2"></i>
        <label class="me-2 mb-0" translate>MIN_DATE</label>
        <input type="date" class="form-control" style="width: auto;" [(ngModel)]="minDate" />
        <button class="btn btn-primary ms-2" (click)="applyDateFilter()" [disabled]="loading" translate>APPLY</button>
      </div>
    </div>
    <lib-filter-list #filterList [configService]="configService" (loaded)="onLoaded($event)"></lib-filter-list>
  `,
  styleUrls: ['./edi-list-wrapper.component.css'],
  standalone: false
})
export class EdiListWrapperComponent<T> implements AfterViewInit, OnDestroy {
  @Input() configService: EdiMinDateConfigService<T>;
  @Input() title: string;

  @ViewChild('filterList') filterList: FilterListComponent<T>;

  public minDate: string;
  public loading = false;
  public showCheckmark = false;
  public showEmptyFilteredSuggestion = false;

  private destroy$ = new Subject<void>();

  ngAfterViewInit(): void {
    this.minDate = this.configService.getMinDate();

    // Subscribe to renderItems to detect when filtered results become empty
    this.filterList.renderItems.pipe(takeUntil(this.destroy$)).subscribe(renderedItems => {
      const hasItems = this.filterList.items && this.filterList.items.length > 0;
      const hasRenderedItems = renderedItems && renderedItems.length > 0;
      this.showEmptyFilteredSuggestion = hasItems && !hasRenderedItems;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  applyDateFilter(): void {
    this.loading = true;
    this.showCheckmark = false;
    this.showEmptyFilteredSuggestion = false;
    this.configService.setMinDate(this.minDate);
  }

  onLoaded(loaded: boolean): void {
    if (loaded && this.loading) {
      this.loading = false;
      this.showCheckmark = true;
      setTimeout(() => {
        this.showCheckmark = false;
      }, 2000);
    }
  }

  loadSixMonthsBack(): void {
    const currentDate = parseISO(this.minDate);
    this.minDate = format(subMonths(currentDate, 6), 'yyyy-MM-dd');
    this.applyDateFilter();
  }
}
